import decoration from "./decorationItem.svg";
import anvelopeImg from "./anvelopeImg.png";

export default {
  decoration,
  anvelopeImg,
};
